export default __webpack_public_path__ + "static/media/home_add_sm_icon.fbb6d263.svg";